import type { SorterResult } from 'antd/es/table/interface';

import { ListVaultsOrderBy } from '@/modules/api/codegen';

import type { VaultsTableRow, VaultsTableSort } from '../types';

export const mapAntdSorterToVaultsTableSort = (sorter: SorterResult<VaultsTableRow>): VaultsTableSort | undefined => {
    const { field, order } = sorter;

    if (typeof field !== 'string' || !order || !(field in ListVaultsOrderBy)) {
        return undefined;
    }

    return {
        orderBy: field as ListVaultsOrderBy,
        orderDirection: order === 'ascend' ? 'asc' : 'desc',
    };
};
